module.exports = __webpack_public_path__ + "img/bars-filter.90c1c9a3.svg";